/* ASKIFY-RESPONDER-CUADRO (borrador, 2026-09-29)
 * «Responder» de Askify abre el cuadro de «Hacer una pregunta» (moderado) en vez de
 * la respuesta de la app, que se publica sola y no se puede borrar.
 *
 * Peor caso: si Askify cambia sus clases o textos, nada coincide y el botón hace lo
 * mismo que hoy. Nunca lanza errores hacia la página: todo va en try/catch.
 */
(function () {
  'use strict';
  if (window.__mahaAskifyResponder) return;
  window.__mahaAskifyResponder = true;

  var BLOQUE = '#ac-pqa-qa-block';
  var ETIQUETA = /^\s*responder\s*$/i;

  function textoPropio(boton) {
    // El botón puede llevar un contador en <span class="ac-qa-badge">; se ignora.
    var t = '';
    boton.childNodes.forEach(function (n) {
      if (n.nodeType === 3) t += n.textContent;
      else if (n.nodeType === 1 && !n.classList.contains('ac-qa-badge') && !n.classList.contains('ac-qa-tooltip')) t += n.textContent;
    });
    return t;
  }

  function esResponder(el) {
    var b = el && el.closest && el.closest('button.ac-qa-small-button');
    if (!b || !b.closest(BLOQUE) || !b.closest('.ac-qa-actions')) return null;
    return ETIQUETA.test(textoPropio(b)) ? b : null;
  }

  var TITULO = 'Responder a esta pregunta';
  var FRASE = 'MAHA revisa tu mensaje antes de publicarlo. No aparecerá de inmediato.';

  function cambiarTexto(el, texto) {
    // Se cambia el nodo de texto existente, no se reemplaza el elemento: React lo deja así.
    if (!el) return;
    var n = [].find.call(el.childNodes, function (x) { return x.nodeType === 3 && x.nodeValue.trim(); });
    if (n) n.nodeValue = texto; else el.textContent = texto;
  }

  function prellenar(texto) {
    var intentos = 0;
    (function buscar() {
      var pop = document.querySelector('.ac-qa-popup');
      var ta = pop && pop.querySelector('textarea#question');
      if (!ta) { if (++intentos < 20) setTimeout(buscar, 100); return; }
      cambiarTexto(pop.querySelector('.ac-qa-popup-title'), TITULO);
      cambiarTexto(pop.querySelector('.ac-qa-popup-sub-title'), FRASE);
      if (!texto || ta.value) return;
      // Askify usa React: hay que usar el setter nativo y avisar con «input».
      var set = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set;
      set.call(ta, texto);
      ta.dispatchEvent(new Event('input', { bubbles: true }));
      try { ta.focus({ preventScroll: true }); ta.setSelectionRange(texto.length, texto.length); } catch (e) {}
    })();
  }

  document.addEventListener('click', function (ev) {
    try {
      var b = esResponder(ev.target);
      if (!b) return;
      var bloque = b.closest(BLOQUE);
      var preguntar = bloque && bloque.querySelector('.ac-qa-ask-button');
      if (!preguntar) return; // sin el botón de preguntar: se deja el comportamiento de hoy
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var item = b.closest('.ac-qa-block-single');
      var q = item && item.querySelector('.ac-qa-question');
      var pregunta = q ? q.textContent.replace(/\s+/g, ' ').trim() : '';
      preguntar.click();
      prellenar(pregunta ? 'Sobre: «' + pregunta.slice(0, 120) + '»\n\n' : '');
    } catch (e) { /* peor caso: comportamiento de hoy */ }
  }, true); // captura: llega antes que el manejador de React de Askify
})();
